/* global google */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {googleApiKey} from '../../constants/config';

export class GoogleMap extends Component {

    static propTypes = {
        style: PropTypes.object,
        marker: PropTypes.shape({
            lat: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired,
            title: PropTypes.string
        })
    }



    componentDidMount() {
        // Connect the initMap() function within this class to the global window context,
        // so Google Maps can invoke it
        window.initMap = this.initMap;
        // Asynchronously load the Google Maps script, passing in the callback reference
        this.loadJS(`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&callback=initMap`);
    }

    loadJS = (src) => {
        const ref = window.document.getElementsByTagName('script')[0];
        const script = window.document.createElement('script');
        script.src = src;
        script.async = true;
        ref.parentNode.insertBefore(script, ref);
    }

    initMap = () => {
        const map = new google.maps.Map(this.refs.map, {
            zoom: 12,
            center: {lat: this.props.marker.lat, lng: this.props.marker.lng},
            disableDefaultUI: true,
        });

        if(this.props.marker.title){
            const infoWindow = new google.maps.InfoWindow({
                content:
                '  <div class="card-body">' +
                '    <h5 class="card-title" style="color:#060606">' + this.props.marker.title + '</h5>' +
                '  </div>',
            });

            const marker = new google.maps.Marker({
                position: {lat: this.props.marker.lat, lng: this.props.marker.lng},
                map: map,
                title: this.props.marker.title,
                animation: google.maps.Animation.DROP,
            });

            google.maps.event.addDomListener(marker, 'click', function() {
                infoWindow.open(map, this);
            });
        }

    }

    render() {
        const style = Object.assign({}, {height: '400px', width: '400px'},this.props.style);
        const otherProps = {...this.props};
        delete otherProps.marker;
        delete otherProps.style;

        return (
            <div>
                <div ref="map"  style={style} {...otherProps}></div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/shared/googlemap.js